import ReduxRestEntity from '../../../../utils/reduxRestEntity';
import DashboardAPI from '../../../../utils/api/dashboardAPI';

const entity = new ReduxRestEntity({
  name: 'dashboard',
  api: DashboardAPI(),
});

export default entity;
